import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initI18n } from "./i18n";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Не найден элемент #root — проверьте index.html");
}

// Приложение монтируется после загрузки словаря: иначе первый кадр
// отрисовывается с необработанными ключами вроде "newsTitle".
initI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
